import { render, staticRenderFns } from "./InicioPantalla.vue?vue&type=template&id=38879c57&scoped=true&"
import script from "./InicioPantalla.vue?vue&type=script&lang=ts&"
export * from "./InicioPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./InicioPantalla.vue?vue&type=style&index=0&id=38879c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38879c57",
  null
  
)

export default component.exports